import contractorInvoiceItem from "./contractorInvoiceItem.component";
import contractorInvoiceItemUrls from "./contractorInvoiceItem.urls";
import ContractorInvoiceItemTransforms from "./contractorInvoiceItem.transforms";

const contractorInvoiceItemModule = angular
  .module("app.components.contractorInvoiceItem", [])
  .component("contractorInvoiceItemPage", contractorInvoiceItem)
  .service("ContractorInvoiceItemTransforms", ContractorInvoiceItemTransforms)
  .config(contractorInvoiceItemUrls);

export default contractorInvoiceItemModule;



// WEBPACK FOOTER //
// ./src/pages/contractorInvoiceItem/contractorInvoiceItem.module.js